<div class="commonDecoration noScroll" :ref="setScrollItem"><ResponsiveImage :src-pc="src.pc" :src-sp="src.sp" :alt="alt"></ResponsiveImage></div>